import { Badge } from "@/client/components/ui/badge";

/**
 * The single, canonical status label for a tenant in the staff UI. Deactivation
 * (PE-991) is orthogonal to `status` in the data model, but for staff it's the
 * one fact that matters, so it takes precedence and we never show two labels at
 * once: deactivated wins, then active (green) / suspended (amber).
 */
export function TenantStatusBadge({
  status,
  deactivatedAt,
}: {
  status: string;
  /** ISO timestamp when deactivated, or null when the tenant is live. */
  deactivatedAt: string | null;
}) {
  if (deactivatedAt) {
    return <Badge variant="destructive">Deactivated</Badge>;
  }
  if (status === "active") {
    return <Badge variant="success">Active</Badge>;
  }
  if (status === "suspended") {
    return <Badge variant="warning">Suspended</Badge>;
  }
  return <Badge variant="outline">{status}</Badge>;
}
